export default __webpack_public_path__ + "static/media/right.6f6797bf.svg";